<template>
  <div class="settings">
    <div class="content">
      <div class="wrapper">
        <div class="main-wrap">

          <div class="settings-header">
            Work Items
            <div class="settings-header__btn">
              <el-button type="success" size="mini" @click="routerLink('settings-dashboard')">Settings Dashboard</el-button>
            </div>
          </div>

          <div>
            <el-dropdown placement="bottom-start" @command="handleCommand">
              <el-button style="margin-right: 20px;" size="small" type="menu" icon="el-icon-edit-outline">{{$t('settings_humanCapitalManagement_addItem')}}</el-button>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item command="normalDay" class="nav-tree__item" size="mini" type="primary" plain>{{$t('settings_humanCapitalManagement_addItem_normalDay')}}</el-dropdown-item>
                <el-dropdown-item command="flexy" class="nav-tree__item" size="mini" type="primary" plain>{{$t('settings_humanCapitalManagement_addItem_flexy')}}</el-dropdown-item>
                <el-dropdown-item command="rotated" class="nav-tree__item" size="mini" type="primary" plain>{{$t('settings_humanCapitalManagement_addItem_rotated')}}</el-dropdown-item>
                <el-dropdown-item command="break" class="nav-tree__item" size="mini" type="primary" plain>{{$t('settings_humanCapitalManagement_addItem_break')}}</el-dropdown-item>
                <el-dropdown-item command="overtime" class="nav-tree__item" size="mini" type="primary">{{$t('settings_humanCapitalManagement_addItem_overtime')}}</el-dropdown-item>
                <el-dropdown-item command="travel" class="nav-tree__item" size="mini" type="primary">{{$t('settings_humanCapitalManagement_addItem_travel')}}</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
            <el-table
                max-height="650"
                :data="tableData"
                style="width: 100%; margin-top: 10px;"
                @row-click="rowClick">
              <el-table-column
                  label="ID"
                  type="index"
                  width="50">
              </el-table-column>
              <el-table-column
                  prop="code"
                  label="Code"
                  width="100">
              </el-table-column>
              <el-table-column
                  prop="type"
                  label="Type"
                  width="100">
              </el-table-column>
              <el-table-column
                  prop="name"
                  label="Name">
              </el-table-column>
              <el-table-column
                  prop="created"
                  label="Created By"
                  width="140">
              </el-table-column>
              <el-table-column
                  label="Action"
                  width="120">
                <template slot-scope="scope">
                  <el-button
                      size="mini"
                      type="primary"
                      plain
                      icon="el-icon-edit"
                      @click="handleEdit(scope.$index, scope.row)"></el-button>
                  <el-button
                      size="mini"
                      type="danger"
                      icon="el-icon-delete"
                      plain
                      @click="handleDelete(scope.$index, scope.row)"></el-button>
                </template>
              </el-table-column>
            </el-table>
            <human-capital-add-item-modal
                @loadList="loadList"
                ref="humanCapitalAddItemModal"/>
            <human-capital-add-flex-item-modal
                @loadList="loadList"
                ref="humanCapitalAddFlexItemModal"/>
            <human-capital-add-break-item-modal
                @loadList="loadList"
                ref="humanCapitalAddBreakItemModal"/>
            <human-capital-add-travel-item-modal
                @loadList="loadList"
                ref="humanCapitalAddTravelItemModal"/>
            <item-info-modal ref="humanCapitalItemInfoModal"/>
            <human-capital-add-rotation-item-modal
                @loadList="loadList"
                ref="humanRotationAddTravelItemModal"/>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import HumanCapitalAddItemModal from "@/components/settings/humanCapitalManagement/AddItemModal";
import HumanCapitalAddFlexItemModal from "@/components/settings/humanCapitalManagement/AddFlexItemModal";
import HumanCapitalAddBreakItemModal from "@/components/settings/humanCapitalManagement/AddBreakItemModal";
import HumanCapitalAddTravelItemModal from "@/components/settings/humanCapitalManagement/AddTravelItemModal";
import ItemInfoModal from "@/components/settings/humanCapitalManagement/ItemInfoModal";
import HumanCapitalAddRotationItemModal from "@/components/settings/humanCapitalManagement/AddRotationItemModal";
export default {
  name: "WorkItems",
  components: {
    HumanCapitalAddRotationItemModal,
    ItemInfoModal,
    HumanCapitalAddFlexItemModal,
    HumanCapitalAddItemModal,
    HumanCapitalAddBreakItemModal,
    HumanCapitalAddTravelItemModal
  },
  data(){
    return {
      tableData: []
    }
  },
  mounted() {
    this.loadList()
  },
  methods:{
    handleCommand(command) {
      switch (command) {
        case 'normalDay':
          this.$refs.humanCapitalAddItemModal.open(command);
          break;
        case 'flexy':
          this.$refs.humanCapitalAddFlexItemModal.open(command);
          break;
        case 'break':
          this.$refs.humanCapitalAddBreakItemModal.open(command);
          break;
        case 'travel':
          this.$refs.humanCapitalAddTravelItemModal.open(command);
          break;
        case 'rotated':
          this.$refs.humanRotationAddTravelItemModal.open(command);
          break;
        case 'overtime':
          console.log('overtime');
          break
      }
    },
    loadList(){
      let loader = this.$loading.show();
      axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
      axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
      axios.get(`/api/v1/workingHoursItem/list?companyId=${this.$route.query.companyId}`)
          .then(response => {
            console.log('response', response.data);
            this.tableData = response.data.fieldsList;
            loader.hide()
          })
          .catch(error => {
            console.log('An error occurred:', error);
            loader.hide()
          });
    },
    handleEdit(index, row) {
      switch (row.type) {
        case 'Normal Day':
          this.$refs.humanCapitalAddItemModal.openEdit(row.type, row.itemId);
          break;
        case 'Flexi':
          this.$refs.humanCapitalAddFlexItemModal.openEdit(row.type, row.itemId);
          break;
        case 'Rotation':
          this.$refs.humanRotationAddTravelItemModal.openEdit(row.type, row.itemId);
          break
      }
    },
    handleDelete(index, row) {
      this.$confirm(this.$t('settings_humanCapitalManagement_ThisWillPermanentlyDeleteTheItem'), this.$t('general_warning'), {
        confirmButtonText: this.$t('general_ok'),
        cancelButtonText: this.$t('general_cancel'),
        type: 'info'
      }).then(() => {
        let loader = this.$loading.show();
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
        axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
        axios.get(`/api/v1/workingHoursItem/delete?companyId=${this.$route.query.companyId}&itemId=${row.itemId}`)
            .then(response => {
              this.notification(this.$t('general_success'), this.$t('notification_itemRemoved'), "success");
              this.loadList();
              loader.hide()
            })
            .catch(error => {
              console.log('An error occurred:', error);
              loader.hide()
            });
      }).catch(() => {
        this.$message({
          type: 'info',
          message: this.$t('settings_businessUnits_deleteCompleted')
        });
      });
    },
    rowClick(row, column, event){
      if (column.label !== 'Action') {
        this.$refs.humanCapitalItemInfoModal.openModal(row);
      }
    },
    notification(title, message, type) {
      this.$notify({
        title: title,
        message: message,
        type: type
      });
    },
    routerLink(page) {
      this.$router.push({name: page, query: { companyId: this.$route.query.companyId}} )
    }
  }
}
</script>

<style lang="scss" scoped>
.settings {
  background: #DfE8F0;
}

.content {
  display: flex;
  min-height: 100vh;
  padding-top: 50px;
  .wrapper{
    background: #fff;
    margin: 10px;
    width: 100%;
    display: flex;
    justify-content: center;
    .main-wrap {
      padding: 20px;
      width: 100%;
    }
    &.animation{
      margin-left: 260px;
      transition: margin-left 500ms ease-out, transform 500ms ease-out;
    }
  }
}
</style>
